var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.blocks),function(block,index){return (_vm.authorizationList.indexOf(block.identifier) !== -1)?_c('content-block',{key:index,attrs:{"content":block.content}}):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }